import React from 'react';

export default function CreditReasonTable({ creditReasons, onReasonUpdateOrDelete }) {
	return (
		<div className="table-view table-responsive" id="setting-tables">
			<table id="credit-reason-table" className="table">
				<thead>
					<tr>
						<th>Credit Reason</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					{creditReasons
						? creditReasons.map(data => (
								<tr key={data.id}>
									<td>{data.reason}</td>
									<td>
										<i
											data-toggle="modal"
											data-target="#confirmationModal"
											className="fa fa-trash-o icon"
											onClick={() => onReasonUpdateOrDelete(data)}
										/>
										<i
											data-toggle="modal"
											data-target="#oneInputEditModal"
											className="fa fa-pencil-square-o icon"
											onClick={() => onReasonUpdateOrDelete(data)}
										/>
									</td>
								</tr>
						  ))
						: null}
				</tbody>
			</table>
		</div>
	);
}
